export default __webpack_public_path__ + "static/interactive-animations-0489ab998eb61c3e1250b6a134732cdc.png";